import { apiService as Service } from '@/services/service'

const url = 'privacy'

export const privacyService = {
	loadCurrent: () =>
		Service.get({
			url: `${url}/current`,
		}),
	acceptCurrent: () =>
		Service.post({
			url: `${url}/current`,
		}),
	rejectTosAndPrivacy: () =>
		Service.delete({
			url: `/profile/reject`,
		}),
}

export default privacyService
